module.exports = __webpack_public_path__ + "img/5.06e926d6.jpg";